// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nj-2";
export var chatLink = "_nj-0";
export var chatText = "_nj-1";